module.exports = __webpack_public_path__ + "img/shield-dollar.922a0814.svg";